<script>
import {
  clientComputed,
  clientMethods,
  programComputed,
  clientProgramMethods,
  alertMethods,
  authComputed,
} from '@state/helpers';
import moment from 'moment';
import { cleverTapMixin } from '@mixins/cleverTap-mixin';
import isEmpty from 'lodash/isEmpty';
import has from 'lodash/has';

import Loader from '@components/_base-loading-spinner.vue';

export default {
  components: {
    Loader,
  },
  props: {},
  data() {
    return {
      error: false,
      isLoading: false,
    };
  },
  mixins: [cleverTapMixin],
  computed: {
    ...clientComputed,
    ...programComputed,
    ...authComputed,
    clientName() {
      if (
        !isEmpty(this.selectedClient) &&
        has(this.selectedClient, 'profile')
      ) {
        return `${this.selectedClient.profile.firstName} ${this.selectedClient.profile.lastName}`;
      } else {
        return null;
      }
    },
  },
  mounted() {},
  methods: {
    ...clientMethods,
    ...clientProgramMethods,
    ...alertMethods,
    async overrideProgram(offset) {
      try {
        this.isLoading = true;
        await this.onProgramOverride(offset).then(() => {
          this.isLoading = false;
        });
        // await this.setSelectedClient(null);
      } catch (e) {
        console.log(e);
      }
    },
    async onProgramOverride(offset) {
      const desProgramId = this.selectedClient.program.program_id;
      const sourceProgramId = this.selectedProgram._id;
      const startFromWeek = 1;
      const today = moment().toISOString();

      const overridePayload = {
        source: {
          program_id: sourceProgramId,
        },
        programDestination: {
          weekNumber: startFromWeek,
          today,
          offset,
        },
      };

      const payload = { overridePayload, desProgramId };
      await this.overrideClientProgram(payload)
        .then((res) => {
          if (res && res.programWeeks) {
            this.setShowAlert();
            this.error = false;
            this.$bvModal.hide('confirmation-program-client-modal');
            this.$bvModal.hide('item-select-modal');

            if (sourceProgramId) {
              const program = sourceProgramId;
              const trainer = this.trainerEmail;
              const client = this.selectedClient.email;
              this.$_pushCleverTapEvent('Assign Program', {
                program,
                trainer,
                client,
              });
            }
          } else {
            this.error = true;
          }
        })
        .catch((e) => console.log(e));
    },
    cancel() {
      this.error = false;
      this.$bvModal.show('item-select-modal');
    },
  },
};
</script>

<template>
  <b-modal
    id="confirmation-program-client-modal"
    centered
    :hide-footer="true"
    @close="error = false"
    no-stacking
  >
    <template v-if="isLoading">
      <Loader />
    </template>
    <template slot="default" v-if="!isLoading">
      <div>
        <p v-if="clientName" class="modal-text-main"
          >Assign program to {{ clientName }}?</p
        >
        <p class="modal-text-second" v-if="clientName">
          Assigning the program to your client could overwrite exiting workouts.
          Are you sure you want to continue?
        </p>
        <p class="modal-text-third">
          Clients can only have one workout per day. When you assign this
          program, workouts on the same day as this program will be erased and
          overridden.
          <strong
            >When assigning to this week, workouts your client completed could
            be lost.</strong
          >
        </p>
        <div class="confirm">
          <BaseButton
            class="btn-secondary btn-round"
            @click="overrideProgram(0)"
          >
            Override this week
          </BaseButton>
          <BaseButton class="btn-primary btn-round" @click="overrideProgram(1)">
            Override next week
          </BaseButton>
          <BaseButton class="btn-primary btn-round cancel" @click="cancel">
            Cancel
          </BaseButton>
        </div>
        <p v-if="error" class="error"
          >Faild program overriding, please try later!</p
        >
      </div>
    </template>
  </b-modal>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.modal-dialog > .modal-content {
  .modal-text-main {
    color: $color-black-one;
    font-size: 28px;
    font-style: normal;
    font-weight: 900;
    letter-spacing: -0.233333px;
    line-height: 28px;
    margin-bottom: 2rem;
    margin-top: 2rem;
    text-align: center;
  }
  .modal-text-second {
    color: $color-black-one;
    font-size: 18px;
    font-weight: 800;
    letter-spacing: -0.233333px;
    text-align: center;
  }
  .modal-text-third {
    color: $color-black-one;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: -0.233333px;
    text-align: center;
  }
  .error {
    color: red;
  }
}

::v-deep .modal-dialog {
  min-width: 580px;
  .modal-content {
    background: $color-white;
    border-radius: 12px !important;
    box-shadow: 0 4px 8px rgba($color-black-wo-rgb, 0.08);
  }
}

::v-deep .modal {
  .modal-header {
    background-color: white;
    border-bottom: none;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 4rem 4rem 0;

    .close {
      color: black;
    }

    .modal-title {
      color: black;
    }
  }

  .modal-body {
    padding: 0 3.3rem 1.5rem;
  }
}

.error-helper {
  color: $color-danger;
  margin-bottom: unset;
  margin-top: 5px;
}
.icon-calendar-alt {
  margin-right: 0.5rem;

  path {
    fill: black;
  }
}

.confirm {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  margin-top: 2rem;
  width: 100%;
  .btn-primary,
  .btn-secondary {
    margin-right: 1rem;
  }
  .btn-primary {
    border: 2px solid $color-action;
    &:hover {
      border-color: $color-primary-three;
    }
  }
  .btn-secondary {
    padding: 0.9rem 2.1rem !important;
  }
  .cancel {
    background-color: transparent;
    border-color: transparent;
    color: $color-dark-gray;
    &:hover {
      background-color: transparent;
      border-color: transparent;
      color: $color-dark-gray;
    }
  }
}
</style>
